'use client'

import { AgencyData } from '@/types/Misc'
import classNames from 'classnames'
import PhoneIcon from '@/icons/header-phone.svg'
import { ContactLinkLabelHiddenMobile } from '@/components/common/header/ContactLink'
import React, { useContext, useEffect } from 'react'
import { ConfigContext } from '@/components/common/ConfigContext'
import { TravelDurationUpdatedEvent } from '@/components/common/header/types'

const SHOW_PHONE_TRESHOLD = 7
const ONE_DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000

export function PhoneNumber(props: { agencyData: AgencyData }) {
  const config = useContext(ConfigContext)!

  const [showPhone, setShowPhone] = React.useState(
    config.header.contactPhone.showByDefault || config.header.contactPhone.showAlways,
  )

  function showHideBasedOnDuration(duration: number) {
    if (duration > SHOW_PHONE_TRESHOLD) {
      setShowPhone(true)
    } else {
      setShowPhone(false)
    }
  }

  useEffect(() => {
    function storeDuration(event: TravelDurationUpdatedEvent) {
      const { startDate, endDate, duration } = event.detail

      if (startDate && endDate) {
        const startDateObject = new Date(startDate)
        const endDateObject = new Date(endDate)
        const differenceInDays = Math.floor(
          (endDateObject?.getTime() - startDateObject?.getTime()) / ONE_DAY_IN_MILLISECONDS,
        )
        showHideBasedOnDuration(differenceInDays)
        return
      }

      if (duration) {
        showHideBasedOnDuration(duration)

        return
      }
    }

    window.addEventListener('TRAVEL_DURATION_UPDATED', storeDuration)

    return () => window.removeEventListener('TRAVEL_DURATION_UPDATED', storeDuration)
  })

  return (
    <a
      href={`tel:${props.agencyData.PhoneE164}`}
      aria-label={props.agencyData.PhoneDisplay}
      className={classNames('flex flex-row items-center space-x-1', { hidden: !showPhone })}
      target="_blank"
      rel="noopener noreferrer"
    >
      <PhoneIcon className="h-[30px] lg:h-[20px]" />
      <ContactLinkLabelHiddenMobile label={props.agencyData.PhoneDisplay} />
    </a>
  )
}
